import React, { useState } from 'react';


const FormInfoItem = ({PlaceHolder,id}) => {
    const [value,setValue] = useState("");
    return (
            <div className='relative'>
                    <input
                      id={id}
                      className="block rounded-md md:py-5 py-3 px-6 w-full text-[0.875rem]  bg-transparent border border-[#dee9ed] appearance-none  focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
                      placeholder=" "
                      onChange={ e => setValue(e.target.value)}
                      value={value}
                    ></input>
                    <label
                      htmlFor={id}
                      className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form  duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3  left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
                    >
                      {PlaceHolder}
                    </label>
            </div>
    );
};

export default FormInfoItem;